import script from "./TagConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./TagConfig.vue?vue&type=script&setup=true&lang=js"

import "./TagConfig.vue?vue&type=style&index=0&id=1833c834&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1833c834"]])

export default __exports__